var nurseslounge_myDashboard_myInbox = {
    open_my_inbox:function($params){
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            setTimeout(function(){
                nurseslounge_myDashboard_myInbox.inbox_open_chat({
                    user_id:libs.memoryGet('user_id'),
                    room_id:atob($params.notification_type_key),
                    my_room_id:$params.my_room_id,
                    limit:30
                });
            }, 1000);
        });
    },
    init: function ($params) {
        nurseslounge_myDashboard_myInbox.inbox_pagination($params);
        nurseslounge_myDashboard_myInbox.inbox_groups_pagination($params);
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxLeft = $inbox.find('.nurseslounge-home-my-inbox-left');
        var $search = $inboxLeft.find('input[name="search"]');
        var $addNewChat = $inboxLeft.find(".add-new-chat");
        var $groupMenu = $inboxLeft.find(".group-menu");
        var $keypressBind;
        $('a[data-toggle="tab"]').on('shown.bs.tab', function ($e) {
            var $target = $($e.target);
            if($target.attr('href') == '#myInbox_groups_tab'){
                var $inboxList = $("#nurseslounge-home-my-inbox .nurseslounge-home-my-inbox-left");
                var $colleaguesList = $inboxList.find(".groups-list");
                var $colleaguesListHeight = $colleaguesList.height() + 10;
                $inboxList.find(".groups-list-wrapper").height($colleaguesListHeight);
                $groupMenu.show();
            }else{
                var $inboxList = $("#nurseslounge-home-my-inbox .nurseslounge-home-my-inbox-left");
                var $colleaguesList = $inboxList.find(".colleagues-list");
                var $colleaguesListHeight = $colleaguesList.height() + 10;
                $inboxList.find(".colleagues-list-wrapper").height($colleaguesListHeight);
                $groupMenu.hide();
            }
        });
        $search.unbind().on('keypress keyup keydown', function(){
            var $that = $(this);
            $params = $.extend({}, $params, {
                search:$that.val()
            });
            try{
                clearTimeout($keypressBind);
            }catch($e){

            }
            $keypressBind = setTimeout(function(){
                nurseslounge_myDashboard_myInbox.inbox_pagination($params);
                nurseslounge_myDashboard_myInbox.inbox_groups_pagination($params);
            }, 800);
        });
        $addNewChat.unbind().click(function(){
            nurseslounge_myDashboard_myInbox.add_new_chat($params);
        });
    },
    inbox_refresh_list_answers:function($obj){
        var $myInbox = $("#nurseslounge-home-my-inbox");
        var $myInboxRight = $myInbox.find('.nurseslounge-home-my-inbox-right');
        var $roomId = $myInboxRight.find('.heading-name-meta:first').data('room_id');
        var $heading = $myInboxRight.find('.heading');
        var $chatWrapper = $myInboxRight.find('.colleagues-chat-wrapper');
        var $reply = $myInboxRight.find('.reply');
        if($roomId == $obj.room_id && $obj.delete){
            $heading.html('');
            $chatWrapper.html('' +
                '<div class="text-center">' +
                '   <h2>Select or search for colleagues on the left to start a conversation.</h2>' +
                '</div>');
            $reply.html('');
        }
        nurseslounge_myDashboard_myInbox.inbox_pagination({
            user_id:libs.memoryGet('user_id')
        });
        nurseslounge_myDashboard_myInbox.inbox_groups_pagination({
            user_id:libs.memoryGet('user_id')
        });
    },
    add_new_chat:function($params){
        var $myInbox = $("#nurseslounge-home-myinbox-create-group");
        var $usersList = $myInbox.find(".users-list");
        var $newUser = $myInbox.find("input[name='newUser']");
        var $groupName = $myInbox.find("input[name='groupName']");
        $myInbox.on('show.bs.modal', function () {
            $newUser.val('');
            $groupName.val('');
        });
        var $btnCreate = $myInbox.find(".btn-create");
        var $chtml = '';
        var $ids = [];
        $params = $.extend({}, $params, {
            pageSize: 10,
            pageNumber: 1,
            show:"my-colleagues"
        });
        nurseslounge_myDashboard_myInbox.add_new_chat_autocomplete(
            $newUser,
            $params,
            '/myDashboard/myInbox/colleagues/get',
            function($userId){
                var $params = {
                    add_user_id:$userId,
                    user_id:libs.memoryGet('user_id')
                };
                $chtml =  '' +
                    '<div class="row w-100 m-0 p-0">' +
                    '   <div class="col-4 offset-4">' +
                    '       <img src="/bimg/NursesLounge/loader.gif" class="img-fluid of-contain">' +
                    '       <h4 class="col-12 text-center my-2">Loading</h4>'+
                    '   </div>' +
                    '</div>';
                if($usersList.find('.item').length == 0){
                    $usersList.html($chtml).promise().done(function(){
                        libs.checkImageLoad($usersList.find('img'), function(){
                            nurseslounge_myDashboard_myInbox.add_new_user_request($params, function($data){
                                var $user = $data.data.user;
                                $newUser.val('');
                                $chtml = '' +
                                    '<li class="shadow p-3 mb-3 bg-white rounded item" data-id="'+$user.id+'">' +
                                    '   <div class="w-100 delete-wrapper">' +
                                    '       <button type="button" class="btn pull-right btn-delete">X</button>' +
                                    '   </div>' +
                                    '   <div class="col align-self-center user-invitation">' +
                                    '     <div class="d-flex">' +
                                    '         <div class="profile-img mr-3">' +
                                    '             <img src="'+$user.profile_image_root_wall+'?resize=80" alt="profile">' +
                                    '         </div>' +
                                    '         <div class="list-info align-self-center w-100">' +
                                    '             <h6>'+$user.long_name+'</h6>' +
                                    '             <p>'+$user.profile.profile+'</p>' +
                                    '         </div>' +
                                    '     </div>' +
                                    '   </div>' +
                                    '</li>';
                                    $usersList.html($chtml).promise().done(function(){
                                        nurseslounge_myDashboard_myInbox.new_item_events();
                                    });
                            });
                        });
                    });
                }else{
                    var $savedHtml = $usersList.html();
                    $usersList.html($chtml).promise().done(function(){
                        libs.checkImageLoad($usersList.find('img'), function() {
                            nurseslounge_myDashboard_myInbox.add_new_user_request($params, function ($data) {
                                var $user = $data.data.user;
                                $newUser.val('');
                                $chtml = '' +
                                    '<li class="shadow p-3 mb-3 bg-white rounded item" data-id="' + $user.id + '">' +
                                    '   <div class="w-100 delete-wrapper">' +
                                    '       <button type="button" class="btn pull-right btn-delete">X</button>' +
                                    '   </div>' +
                                    '   <div class="col align-self-center user-invitation">' +
                                    '     <div class="d-flex">' +
                                    '         <div class="profile-img mr-3">' +
                                    '             <img src="' + $user.profile_image_root_wall + '?resize=80" alt="profile">' +
                                    '         </div>' +
                                    '         <div class="list-info align-self-center w-100">' +
                                    '             <h6>' + $user.long_name + '</h6>' +
                                    '             <p>' + $user.profile.profile + '</p>' +
                                    '         </div>' +
                                    '     </div>' +
                                    '   </div>' +
                                    '</li>';
                                $usersList.html($savedHtml + $chtml).promise().done(function () {
                                    nurseslounge_myDashboard_myInbox.new_item_events();
                                });
                            });
                        });
                    });
                }
            }
        );
        $btnCreate.unbind().click(function(){
            var $groupNameVal = $groupName.val();
            if($groupNameVal != ''){
                $usersList.find('.item').each(function($i, $v){
                    $ids.push($($v).data('id'));
                });
                nurseslounge_myDashboard_myInbox.create_new_chat_request({
                    user_id:libs.memoryGet('user_id'),
                    group_name:$groupNameVal,
                    ids:$ids
                }, function($data){
                    $groupName.val('');
                    $usersList.html('');
                    $myInbox.modal('hide');
                    $("a[href='#myInbox_groups_tab']").click();
                    setTimeout(function(){
                        socketFunctions.inbox_refresh_list({
                            room_id:$data.data.room_id,
                            delete:false
                        });
                        nurseslounge_myDashboard_myInbox.inbox_open_chat({
                            user_id:libs.memoryGet('user_id'),
                            my_room_id:libs.memoryGet('my_room_id'),
                            room_id:$data.data.room_id,
                            limit:30
                        });
                    }, 1000);
                });
            }else{
                alert("You have to chose a name for the group");
            }
        });
        $myInbox.modal('show');
    },
    //Popup
    add_new_chat_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $arrId = [];
        var $arrData = [];
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $arrId.length = 0;
                        $arrData.length = 0;
                        $value = '';
                        $.each($data,function($i,$v){
                            $arrData.push('"'+$v.value+'"');
                            $arrId.push([$v.id, $v.value]);
                        });
                        response(JSON.parse("["+$arrData.join(",")+"]"));
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value).blur();
                $.each($arrId, function($i, $v){
                    if($v[1] == $value){
                        cback($v[0]);
                    }
                });
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    add_new_user_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/group/userAdd',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    cback($data);
                }
            }
        });
    },
    new_item_events:function(){
        var $myInbox = $("#nurseslounge-home-myinbox-create-group");
        var $usersList = $myInbox.find(".users-list");
        var $item = $usersList.find('.item');
        $item.unbind().click(function(){
            var $that = $(this);
            $that.remove();
        });
    },
    create_new_chat_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/create',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Pagination
    inbox_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $inboxList = $("#nurseslounge-home-my-inbox .nurseslounge-home-my-inbox-left");
        var $colleaguesList = $inboxList.find(".colleagues-list");
        var $paginationNav = $inboxList.find('.pagination-nav:eq(0)');
        var $resultInfo = $inboxList.find(".result-info-count:eq(0)");
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('inbox_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        try{
            $paginationObj = $paginationNav.pagination({
                pageSize:4,
                showPageNumbers: true,
                showPrevious: true,
                showNext: true,
                showNavigator: true,
                showFirstOnEllipsisShow: true,
                showLastOnEllipsisShow: true,
                dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/myInbox/rooms/users/get",
                locator: 'data.chat_room_users',
                ajax:{
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$params,
                    beforeSend: function() {
                        $colleaguesList.html(nurseslounge_myDashboard_myInbox.inbox_chat_room_users_preview());
                    },
                    complete:function($data){
                        libs.expire($data.responseJSON);
                    }
                },
                totalNumberLocator: function($data) {
                    return $data.data.total;
                },
                callback: function($data, $pagination) {
                    $loaded = true;
                    if($colleaguesList.length > 0 && $colleaguesList.offset().top > 0 && $afterFirstPagination){
                        $('html, body').animate({scrollTop:$colleaguesList.offset().top - 100});
                    }else{
                        $afterFirstPagination = true;
                    }
                    var $pageNumber = $pagination.pageNumber;
                    var $pageSize = $pagination.pageSize;
                    var $totalNumber = $pagination.totalNumber;
                    var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                    var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                    $paginationNav.removeClass('loading');
                    $resultInfo.removeClass('loading').html('<strong>Showing ' + $first + ' - ' + $last + ' of ' + $totalNumber + '</strong> results for <span class="link-color">Colleagues</span>');
                    var $chtml = nurseslounge_myDashboard_myInbox.inbox_chat_room_users_html($data);
                    if($chtml != ''){
                        $paginationNav.show();
                        $resultInfo.show();
                        $colleaguesList.show();
                        libs.checkImageLoad($($chtml).find('img'), function () {
                            $colleaguesList.html('').html($chtml).promise().done(function () {
                                var $colleaguesListHeight = $colleaguesList.height() + 10;
                                $inboxList.find(".colleagues-list-wrapper").height($colleaguesListHeight);
                                nurseslounge_myDashboard_myInbox.inbox_chat_room_users_events();
                            });
                        });
                    }else{
                        $paginationNav.hide();
                        $resultInfo.hide();
                        $colleaguesList.hide();
                    }
                }
            });
            libs.memorySave('inbox_pagination', $paginationObj);
            $reload = setTimeout(function(){
                if(!$loaded){
                    nurseslounge_myDashboard_myInbox.inbox_pagination($params);
                }else{
                    clearTimeout($reload);
                }
            }, 10000);
        }catch ($e){

        }
    },
    inbox_groups_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $inboxList = $("#nurseslounge-home-my-inbox .nurseslounge-home-my-inbox-left");
        var $colleaguesList = $inboxList.find(".groups-list");
        var $paginationNav = $inboxList.find('.pagination-nav:eq(1)');
        var $resultInfo = $inboxList.find(".result-info-count:eq(1)");
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('inbox_groups_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        try{
            $paginationObj = $paginationNav.pagination({
                pageSize:4,
                showPageNumbers: true,
                showPrevious: true,
                showNext: true,
                showNavigator: true,
                showFirstOnEllipsisShow: true,
                showLastOnEllipsisShow: true,
                dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/myInbox/rooms/groups/get",
                locator: 'data.chat_room_groups',
                ajax:{
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$params,
                    beforeSend: function() {
                        $colleaguesList.html(nurseslounge_myDashboard_myInbox.inbox_chat_room_users_preview());
                    },
                    complete:function($data){
                        libs.expire($data.responseJSON);
                    }
                },
                totalNumberLocator: function($data) {
                    return $data.data.total;
                },
                callback: function($data, $pagination) {
                    $loaded = true;
                    if($colleaguesList.length > 0 && $colleaguesList.offset().top > 0 && $afterFirstPagination){
                        $('html, body').animate({scrollTop:$colleaguesList.offset().top - 100});
                    }else{
                        $afterFirstPagination = true;
                    }
                    var $pageNumber = $pagination.pageNumber;
                    var $pageSize = $pagination.pageSize;
                    var $totalNumber = $pagination.totalNumber;
                    var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                    var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                    $paginationNav.removeClass('loading');
                    $resultInfo.removeClass('loading').html('<strong>Showing ' + $first + ' - ' + $last + ' of ' + $totalNumber + '</strong> results for <span class="link-color">Groups</span>');
                    var $chtml = nurseslounge_myDashboard_myInbox.inbox_chat_room_users_html($data);
                    if($chtml != ''){
                        $paginationNav.show();
                        $resultInfo.show();
                        $colleaguesList.show();
                        libs.checkImageLoad($($chtml).find('img'), function () {
                            $colleaguesList.html('').html($chtml).promise().done(function () {
                                var $colleaguesListHeight = $colleaguesList.height() + 10;
                                $inboxList.find(".groups-list-wrapper").height($colleaguesListHeight);
                                nurseslounge_myDashboard_myInbox.inbox_chat_group_users_events();
                            });
                        });
                    }else{
                        $paginationNav.hide();
                        $resultInfo.hide();
                        $colleaguesList.hide();
                    }
                }
            });
            libs.memorySave('inbox_groups_pagination', $paginationObj);
            $reload = setTimeout(function(){
                if(!$loaded){
                    nurseslounge_myDashboard_myInbox.inbox_groups_pagination($params);
                }else{
                    clearTimeout($reload);
                }
            }, 10000);
        }catch ($e){

        }
    },
    inbox_chat_room_users_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=1; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded item">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-3 loading">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h5 class="loading">' +
                '                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h5>' +
                '                    <p class="loading">' +
                '                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>' +
                '';
        }
        return $chtml;
    },
    inbox_chat_room_users_html:function($chat_room_users){
        var $chtml = '';
        $.each($chat_room_users, function($i, $v){
            var $img = $v.chat_rooms.chat_image_root_wall;
            var $name = $v.chat_rooms.name;
            $chtml += '' +
                '<li class="shadow p-3 mb-3 bg-white rounded item open-chat" data-room_id="'+$v.room_id+'" data-url="'+$v.chat_rooms.user_profile_url+'" data-name="'+$v.chat_rooms.name+'">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-3">';
                if($v.chat_rooms.user_id){
                    $chtml += '<img src="'+$img+'?resize=80" alt="profile">';
                }
            $chtml += '' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">';
                if($name.length > 30){
                    $name = $name.substr(0, 30);
                }
            $chtml += '<h5>' + $name + '</h5>';
            if($v.chat_rooms.user_profile.profile){
                $chtml += '' +
                '                    <p>' +
                $v.chat_rooms.user_profile.profile +
                '                    </p>';
            }
            $chtml += '' +
                '                </div>';
                if($v.inbox_messages > 0){
                    $chtml += '' +
                        '                <span class="badge badge-dark notifications-alert">' +
                        $v.inbox_messages +
                        '                </span>';
                }
            $chtml += '' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>' +
                '';
        });
        return $chtml;
    },
    //Events
    inbox_chat_room_users_events:function(){
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxLeft = $inbox.find('.nurseslounge-home-my-inbox-left');
        var $colleaguesList = $inboxLeft.find('.colleagues-list');
        var $openChat = $colleaguesList.find('.open-chat');
        $openChat.unbind().click(function(){
            var $that = $(this);
            var $roomId = $that.data('room_id');
            nurseslounge_myDashboard_myInbox.inbox_open_chat({
                user_id:libs.memoryGet('user_id'),
                my_room_id:libs.memoryGet('my_room_id'),
                room_id:$roomId,
                limit:30
            });
        });
    },
    inbox_chat_group_users_events:function(){
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxLeft = $inbox.find('.nurseslounge-home-my-inbox-left');
        var $colleaguesList = $inboxLeft.find('.groups-list');
        var $openChat = $colleaguesList.find('.open-chat');
        $openChat.unbind().click(function(){
            var $that = $(this);
            var $roomId = $that.data('room_id');
            var $myRoomId = $that.data('my_room_id');
            nurseslounge_myDashboard_myInbox.inbox_open_chat({
                user_id:libs.memoryGet('user_id'),
                my_room_id:libs.memoryGet('my_room_id'),
                room_id:$roomId,
                limit:30
            });
        });
    },
    inbox_open_chat:function($params){
        socketFunctions.inbox_open_chat_room_by_id($params);
    },
    inbox_open_chat_room_by_id_answer:function($data){
        var $usersIds = $data.users_ids;
        var $room = $data.room;
        var $chat = $room.chat;
        var $messages = $room.messages;
        var $isOwner = $room.is_owner;
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxRight = $inbox.find('.nurseslounge-home-my-inbox-right');
        var $chatWrapper = $inboxRight.find('.colleagues-chat-wrapper');
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        var $image = $chat && $chat.chat_image_root ? $chat.chat_image_root : 'bimg/NursesLounge/friend-avatar.png';
        var $chatName = $chat && $chat.name ? $chat.name : '';
        var $chatId = $chat && $chat.id ? $chat.id : '';
        var $chatUserId = $chat && $chat.user_id ? $chat.user_id : null;
        if($.inArray($userId, $usersIds) > -1) {
            if($chatUserId){
                $chtml += '' +
                    '<div class="col-1 m-0 p-0 heading-avatar">' +
                    '    <div class="heading-avatar-icon">' +
                    '        <img src="'+$image+'">' +
                    '    </div>' +
                    '</div>';
            }else{
                $chtml += '' +
                    '<div class="col-1 m-0 p-0"></div>';
            }
            if($chatName.length > 30){
                $chatName = $chatName.substr(0, 30);
            }
            $chtml += '' +
            '<div class="col-9 heading-name">' +
            '    <a class="heading-name-meta" data-room_id="'+$chatId+'">'+$chatName+'</a>' +
            '</div>' +
            '<div class="col-2">' +
            '    <div class="pull-right">' +
            '        <a class="dropdown-toggle" type="button" id="chatDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' +
            '            <i class="fa fa-ellipsis-v fa-2x heading-dot pull-right" aria-hidden="true"></i>' +
            '        </a>' +
            '        <div class="dropdown-menu chat-dropdown-menu" aria-labelledby="chatDropdownMenu">' +
            '            <a class="dropdown-item option" data-option="detail" href="javascript:void(0)">Chat room details</a>' +
            '            <a class="dropdown-item option" data-option="delete_messages" href="javascript:void(0)">Delete Messages</a>';
            if(!$chatUserId){
                $chtml += '  <a class="dropdown-item option" data-option="delete_chat" href="javascript:void(0)">Delete Chat</a>';
            }
            $chtml += '' +
            '        </div>' +
            '    </div>' +
            '</div>';
        }
        var $heading = $inboxRight.find('.heading');
        $heading.html($chtml).promise().done(function(){
            var $reply = $inboxRight.find('.reply');
            $chtml = '';
            if($.inArray($userId, $usersIds) > -1) {
                $chtml += '' +
                    '<div class="col-sm-1 col-xs-1 reply-emojis">' +
                    '&nbsp;&nbsp;&nbsp;&nbsp;' +
                    //'    <i class="fa fa-smile-o fa-2x"></i>' +
                    '</div>' +
                    '<div class="col-sm-9 col-xs-9 reply-main">' +
                    '    <textarea class="form-control" rows="1" name="comment"></textarea>' +
                    '</div>' +
                    '<div class="col-sm-1 col-xs-1 reply-recording">' +
                    '&nbsp;&nbsp;&nbsp;&nbsp;' +
                    //'    <i class="fa fa-microphone fa-2x" aria-hidden="true"></i>' +
                    '</div>' +
                    '<div class="col-sm-1 col-xs-1 reply-send">' +
                    '    <i class="fa fa-send fa-2x" aria-hidden="true">' +
                    '    </i>' +
                    '</div>';
            }
            $reply.html($chtml).promise().done(function(){
                $chtml = '';
                $.each($messages, function($i, $v){
                    if($userId == $v.user_id){
                        $chtml += '' +
                            '<div class="row message-body message" data-id="'+$v.id+'">' +
                            '    <div class="col-sm-12 message-main-sender">' +
                            '        <div class="sender">' +
                            '            <span class="message-time pull-right">' +
                            $v.created +
                            '            </span>' +
                            '            <div class="message-text">' +
                            $v.message +
                            '            </div>' +
                            '        </div>' +
                            '    </div>' +
                            '</div>';
                    }else{
                        $chtml += '' +
                            '<div class="row message-body message" data-id="'+$v.id+'">' +
                            '    <div class="col-sm-12 message-main-receiver">' +
                            '        <div class="receiver">' +
                            '            <span class="message-time pull-right">' +
                            $v.created +
                            '            </span>' +
                            '            <div class="message-text-title">' +
                            $v.long_name +
                            '            </div>' +
                            '            <div class="message-text">' +
                            $v.message +
                            '            </div>' +
                            '        </div>' +
                            '    </div>' +
                            '</div>';
                    }
                });
                $chatWrapper.html('').html($chtml).promise().done(function(){
                    var $scrollHeight = $chatWrapper[0].scrollHeight;
                    var $offsetHeight = $chatWrapper[0].offsetHeight;
                    var $scrollTop = $scrollHeight - $offsetHeight;
                    $chatWrapper.scrollTop($scrollTop);
                    $chatWrapper.unbind().scroll(function(){
                        var $that = $(this);
                        var $scrollHeight = $that[0].scrollHeight;
                        var $offsetHeight = $that[0].offsetHeight;
                        var $scrollTop = $scrollHeight - $offsetHeight;
                        if($scrollTop > 20 && $that.scrollTop() < 20){
                            var $inbox = $("#nurseslounge-home-my-inbox");
                            var $inboxRight = $inbox.find('.nurseslounge-home-my-inbox-right');
                            var $chatWrapper = $inboxRight.find('.colleagues-chat-wrapper');
                            var $messageDivs = $chatWrapper.find('.message');
                            socketFunctions.inbox_refresh_top_room({
                                user_id: $userId,
                                room_id:$chat.id,
                                offset:$messageDivs.length,
                                limit:30
                            });
                        }
                    });
                    nurseslounge_myDashboard_myInbox.inbox_open_chat_room_by_id_answer_events($data);
                });
            });
        });
        nurseslounge_myDashboard_myInbox.inbox_pagination({user_id:libs.memoryGet('user_id')});
        nurseslounge_myDashboard_myInbox.inbox_groups_pagination({user_id:libs.memoryGet('user_id')});
    },
    inbox_open_chat_room_by_id_answer_events:function($data){
        var $myRoomId = libs.memoryGet('my_room_id');
        var $userId = libs.memoryGet('user_id');
        var $room = $data.room;
        var $chat = $room.chat;
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxRight = $inbox.find('.nurseslounge-home-my-inbox-right');
        var $comment = $inboxRight.find('textarea[name="comment"]');
        var $replySend = $inboxRight.find('.reply-send');
        var $message = '';
        var $params = {};
        var $heading = $inboxRight.find('.heading');
        var $option = $heading.find('.option');
        var $headingNameMeta = $heading.find('.heading-name-meta');
        $comment.unbind().on('keypress',function($e) {
            if($e.which == 13) {
                $message = $comment.val();
                $params = {
                    user_id: $userId,
                    room_id:$chat.id,
                    my_room_id:$myRoomId,
                    message: $message
                };
                $comment.val('');
                nurseslounge_myDashboard_myInbox.inbox_write_message_request($params, function(){
                    socketFunctions.inbox_refresh_room({
                        user_id: $userId,
                        room_id:$chat.id,
                        my_room_id:$myRoomId,
                        limit:30
                    });
                });
            }
        });
        $replySend.unbind().click(function () {
            $message = $comment.val();
            $params = {
                user_id: $userId,
                room_id:$chat.id,
                my_room_id:$myRoomId,
                message: $message
            };
            $comment.val('');
            nurseslounge_myDashboard_myInbox.inbox_write_message_request($params, function(){
                socketFunctions.inbox_refresh_room({
                    user_id: $userId,
                    room_id:$chat.id,
                    my_room_id:$myRoomId,
                    limit:30
                });
            });
        });
        $option.unbind().click(function(){
            var $modal = $("#nurseslounge-home-myinbox-group-manager");
            var $usersList = $modal.find('.users-list');
            var $groupImage = $modal.find('.group_image');
            var $groupName = $modal.find('.group_name');
            var $that = $(this);
            var $option = $that.data('option');
            var $roomId = $headingNameMeta.data('room_id');
            var $chtml = '';
            var $params = {
                user_id:libs.memoryGet('user_id'),
                room_id:$roomId,
                my_room_id:$myRoomId
            };
            switch($option){
                case 'detail':
                    nurseslounge_myDashboard_myInbox.inbox_information_request($params, function($data){
                        var $chatRoom = $data.data.chat_rooms;
                        var $chatRoomUsers = $data.data.chat_room_users;
                        var $canEdit = $data.data.is_owner == 1;
                        var $groupChatRoom = $data.data.group_chat_room;
                        var $image = '';
                        if($chatRoom.chat_image_root){
                            $image = '/images/' + $chatRoom.chat_image_root;
                        }else{
                            $image = '/bimg/NursesLounge/friend-avatar.png?resize=80';
                        }
                        $chtml = '';
                        $chtml += '' +
                            '<div class="profile-img mr-3">'+
                            '   <img src="'+$image+'" alt="camera">';
                        if($groupChatRoom) {
                            $chtml += '' +
                                '<div class="camera-btn">' +
                                '   <span class="image-change">' +
                                '       <a class="dropdown-toggle" type="button" id="chatImageDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' +
                                '           <img src="/bimg/NursesLounge/camera.png" alt="camera">' +
                                '       </a>' +
                                '       <div class="dropdown-menu chat-image-dropdown-menu" aria-labelledby="chatImageDropdownMenu">' +
                                '           <a class="dropdown-item option" data-option="camera" href="javascript:void(0)">Camera</a>' +
                                '           <a class="dropdown-item option" data-option="storage" href="javascript:void(0)">Storage</a>' +
                                '           <a class="dropdown-item option" data-option="delete" href="javascript:void(0)">Delete</a>' +
                                '       </div>' +
                                '   </span>'+
                                '</div>';
                        }
                        $chtml += '' +
                            '</div>'+
                            '<div class="col-10 offset-1">' +
                            '   <button type="button" class="camera-button btn back-camera-picture">x</button>' +
                            '   <div class="my-room-camera"></div>' +
                            '   <div class="camera-buttons">' +
                            '       <button type="button" class="camera-button btn take-camera-picture active">Take Picture</button>' +
                            '       <button type="button" class="camera-button btn save-camera-picture"> Save Picture </button>' +
                            '   </div>' +
                            '</div>';
                        $groupImage.html($chtml).promise().done(function(){
                        $groupImage = $modal.find('.group_image');
                        var $chatImageDropdownMenu = $groupImage.find('.chat-image-dropdown-menu .option');
                            $chatImageDropdownMenu.unbind().click(function(){
                                var $that = $(this);
                                var $option = $that.data('option');
                                $params = $.extend({}, $params, {
                                    option:$option
                                });
                                switch($option){
                                    case 'camera':
                                        nurseslounge_myDashboard_myInbox.inbox_open_camera_request($params);
                                        break;
                                    case 'storage':
                                        nurseslounge_myDashboard_myInbox.inbox_open_storage_request($params);
                                        break;
                                    case 'delete':
                                        nurseslounge_myDashboard_myInbox.inbox_delete_image_request($params, function(){
                                            nurseslounge_myDashboard_myInbox.inbox_open_chat({
                                                user_id:libs.memoryGet('user_id'),
                                                room_id:$chat.id,
                                                my_room_id:$myRoomId,
                                                limit:30
                                            });
                                        });
                                        break;
                                }
                            });
                            $chtml = '';
                            $chtml += '' +
                                '<div class="col-12 mx-5 p-0">'+
                                '<div class="input-group mb-3">';
                            if($groupChatRoom){
                                $chtml += '' +
                                    '<div class="chatroom-name-input" style="width:70%;">' +
                                    '<input class="form-control" type="text" name="group_name" value="'+$chatRoom.name+'">' +
                                    '</div>';
                            }
                            $chtml += '' +
                                '<div class="chatroom-name input-group-text col-9">' +
                                $chatRoom.name +
                                '</div>';
                            if($groupChatRoom){
                                $chtml += '' +
                                    '<div class="input-group-append">' +
                                    '   <button type="button" class="btn btn-secondary pull-right btn-edit">' +
                                    '       <i class="fa fa-edit"></i>' +
                                    '   </button>' +
                                    '</div>';
                            }
                            $chtml += '' +
                                '</div>' +
                                '</div>';
                            $groupName.html($chtml).promise().done(function () {
                                $groupName = $modal.find('.group_name');
                                var $btnEdit = $groupName.find('.btn-edit');
                                var $chatRoomNameImput = $groupName.find('.chatroom-name-input');
                                var $chatRoomName = $groupName.find('.chatroom-name');
                                var $groupNameInput = $groupName.find('input[name="group_name"]');
                                var $edit = 0;
                                $btnEdit.unbind().click(function(){
                                    if($edit == 0){
                                        $chatRoomName.hide();
                                        $chatRoomNameImput.show();
                                        $btnEdit.html('<i class="fa fa-save"></i>');
                                        var $groupNameVal = $groupNameInput.val();
                                        $params = $.extend({}, $params, {
                                            group_name:$groupNameInput.val()
                                        });
                                        $btnEdit.unbind().click(function(){
                                            nurseslounge_myDashboard_myInbox.inbox_edit_information_request($params, function($data){
                                                $chatRoomName.html($groupNameVal).promise().done(function(){
                                                    $chatRoomName.show();
                                                    $chatRoomNameImput.hide();
                                                    $btnEdit.html('<i class="fa fa-edit"></i>');
                                                    $edit = 0;
                                                });
                                            });
                                        });
                                        $edit = 1;
                                    }else{
                                        $chatRoomName.show();
                                        $chatRoomNameImput.hide();
                                        $btnEdit.html('<i class="fa fa-edit"></i>');
                                        $edit = 0;
                                    }
                                });

                                $chtml = '';
                                $.each($chatRoomUsers, function($i, $v){
                                    var $isOwner = $v.is_owner == 1;
                                    var $user = $v.user;
                                    $chtml += '' +
                                        '<li class="shadow p-3 mb-3 bg-white rounded item" data-id="'+$user.id+'">';
                                    if($canEdit && !$isOwner){
                                        $chtml += '' +
                                            '   <div class="w-100 delete-wrapper">' +
                                            '       <button type="button" class="btn pull-right btn-delete">X</button>' +
                                            '   </div>';
                                    }
                                    $chtml += '' +
                                        '   <div class="col align-self-center user-invitation">' +
                                        '     <div class="d-flex">' +
                                        '         <div class="profile-img mr-3">' +
                                        '             <img src="'+$user.profile_image_root_wall+'?resize=80" alt="profile">' +
                                        '         </div>' +
                                        '         <div class="list-info align-self-center w-100">' +
                                        '             <h6>'+$user.long_name+'</h6>' +
                                        '             <p>'+$user.profile.profile+'</p>' +
                                        '         </div>';
                                    if($isOwner) {
                                        $chtml += '' +
                                            '         <div class="list-info align-self-center w-100">' +
                                            '             <small class="pull-right">Chat Room Admin</small>' +
                                            '         </div>';
                                    }
                                    $chtml += '' +
                                        '     </div>' +
                                        '   </div>' +
                                        '</li>';
                                });
                                $usersList.html($chtml).promise().done(function(){
                                    nurseslounge_myDashboard_myInbox.inbox_delete_user($params);
                                });
                                $modal.modal('show');
                            });
                        });
                    });
                    break;
                case 'delete_messages':
                    nurseslounge_myDashboard_myInbox.inbox_delete_messages_request($params, function(){
                        nurseslounge_myDashboard_myInbox.inbox_open_chat({
                            user_id:libs.memoryGet('user_id'),
                            room_id:$roomId,
                            my_room_id:$myRoomId,
                            limit:30
                        });
                    });
                    break;
                case 'delete_chat':
                    socketFunctions.inbox_refresh_list({
                        room_id:$roomId,
                        delete:true
                    });
                    nurseslounge_myDashboard_myInbox.inbox_delete_group_request($params, function(){
                        nurseslounge_myDashboard_myInbox.inbox_groups_pagination({
                            user_id:libs.memoryGet('user_id')
                        });
                    });
                    break;
            }
        });
    },
    //Camera
    inbox_open_camera_request:function($params){
        var $modal = $("#nurseslounge-home-myinbox-group-manager");
        var $groupImage = $modal.find('.group_image');
        var $groupName = $modal.find('.group_name');
        var $myRoomCamera = $modal.find('.my-room-camera');
        var $cameraButtons = $modal.find('.camera-buttons');
        var $takeCameraPicture = $cameraButtons.find('.take-camera-picture');
        var $saveCameraPicture = $cameraButtons.find('.save-camera-picture');
        var $backCameraButtons = $modal.find('.back-camera-picture');
        var $profileImg = $groupImage.find('.profile-img');
        var $profileImgImg = $profileImg.find('img:first');
        $profileImg.hide();
        $groupName.hide();
        $myRoomCamera.show();
        $cameraButtons.show();
        $backCameraButtons.show();
        Webcam.attach('.my-room-camera');
        $backCameraButtons.unbind().click(function(){
            $profileImg.show();
            $groupName.show();
            $myRoomCamera.hide();
            $cameraButtons.hide();
            $backCameraButtons.hide();
            Webcam.reset();
        });
        $backCameraButtons.css('marginTop', -20);
        $cameraButtons.css('top', 0);
        $saveCameraPicture.removeClass('active');
        $takeCameraPicture.html('Take Picture').unbind().click(function(){
            Webcam.snap( function($imageBase64) {
                $myRoomCamera.html('<img src="'+$imageBase64+'" id="my-room-camera-previous-image">').promise().done(function(){
                    var $image = $("#my-room-camera-previous-image").cropme({
                        "container": {
                            "width": $myRoomCamera.width(),
                            "height": $myRoomCamera.height()
                        },
                        "viewport": {
                            "width": ($myRoomCamera.width() - 140),
                            "height": ($myRoomCamera.width() - 140),
                            "type": "circle",
                            "border": {
                                "width": 5,
                                "enable": true,
                                "color": "#ffffff"
                            }
                        },
                        "zoom": {
                            "enable": true,
                            "mouseWheel": true,
                            "slider": true
                        },
                        "rotation": {
                            "slider": false,
                            "enable": false,
                            "position": "left"
                        },
                        "transformOrigin": "viewport"
                    });
                    $saveCameraPicture.unbind().click(function(){
                        $image.cropme('crop', {
                            type: 'base64'
                        }).then(function($imageBase64) {
                            $params = $.extend({}, $params, {
                                image:$imageBase64
                            });
                            nurseslounge_myDashboard_myInbox.inbox_save_chat_room_request($params, function($data){
                                $profileImg.show();
                                $groupName.show();
                                $myRoomCamera.hide();
                                $backCameraButtons.hide();
                                $cameraButtons.hide();
                                $profileImgImg.attr('src', $imageBase64);
                                nurseslounge_myDashboard_myInbox.inbox_open_chat({
                                    user_id:libs.memoryGet('user_id'),
                                    room_id:$params.room_id,
                                    my_room_id:$params.my_room_id,
                                    limit:30
                                });
                            });
                        });
                    }).addClass('active');
                    $takeCameraPicture.html('Reset').unbind().click(function(){
                        nurseslounge_myDashboard_myInbox.inbox_open_camera_request($params);
                    });
                    $backCameraButtons.css('marginTop', 0);
                    $cameraButtons.css('top', 15);
                });
            });
        });
    },
    inbox_open_storage_request:function($params){
        var $modal = $("#nurseslounge-home-myinbox-group-manager");
        var $groupImage = $modal.find('.group_image');
        var $groupName = $modal.find('.group_name');
        var $myRoomCamera = $modal.find('.my-room-camera');
        var $cameraButtons = $modal.find('.camera-buttons');
        var $takeCameraPicture = $cameraButtons.find('.take-camera-picture');
        var $saveCameraPicture = $cameraButtons.find('.save-camera-picture');
        var $backCameraButtons = $modal.find('.back-camera-picture');
        var $profileImg = $groupImage.find('.profile-img');
        var $profileImgImg = $profileImg.find('img:first');
        $myRoomCamera.parent().find('input[name="file"]').remove();
        $myRoomCamera.after('<input type="file" name="file" accept="image/*" style="display: none;">');
        $groupImage = $modal.find('.group_image');
        var $file = $groupImage.find('input[name="file"]');
        $file.unbind().change(function(){
            var $that = this;
            $myRoomCamera.html('<img src="data:," id="my-room-camera-previous-image">').promise().done(function(){
                libs.renderImage($that, '#my-room-camera-previous-image');
                var $image = $("#my-room-camera-previous-image").cropme({
                    "container": {
                        "width": $myRoomCamera.width(),
                        "height": $myRoomCamera.height()
                    },
                    "viewport": {
                        "width": ($myRoomCamera.width() - 140),
                        "height": ($myRoomCamera.width() - 140),
                        "type": "circle",
                        "border": {
                            "width": 5,
                            "enable": true,
                            "color": "#ffffff"
                        }
                    },
                    "zoom": {
                        "enable": true,
                        "mouseWheel": true,
                        "slider": true
                    },
                    "rotation": {
                        "slider": false,
                        "enable": false,
                        "position": "left"
                    },
                    "transformOrigin": "viewport"
                });
                $profileImg.hide();
                $groupName.hide();
                $cameraButtons.show();
                $myRoomCamera.show();
                $backCameraButtons.show();
                $backCameraButtons.unbind().click(function(){
                    $profileImg.show();
                    $groupName.show();
                    $myRoomCamera.hide();
                    $backCameraButtons.hide();
                    $backCameraButtons.css('marginTop', -30);
                });
                $saveCameraPicture.unbind().click(function () {
                    $image.cropme('crop', {
                        type: 'base64'
                    }).then(function($imageBase64) {
                        $params = $.extend({}, $params, {
                            image:$imageBase64
                        });
                        nurseslounge_myDashboard_myInbox.inbox_save_chat_room_request($params, function($data){
                            $profileImg.show();
                            $groupName.show();
                            $myRoomCamera.hide();
                            $backCameraButtons.hide();
                            $cameraButtons.hide();
                            $profileImgImg.attr('src', $imageBase64);
                            nurseslounge_myDashboard_myInbox.inbox_open_chat({
                                user_id:libs.memoryGet('user_id'),
                                room_id:$params.room_id,
                                my_room_id:$params.my_room_id,
                                limit:30
                            });
                        });
                    });
                }).addClass('active');
            });
        }).click();
        $takeCameraPicture.html('Select Picture').unbind().click(function(){
            $file.click();
        });
    },
    inbox_save_chat_room_request:function($params, cback){
        var $image = libs.b64toBlob($params.image);
        var $formData = new FormData();
        $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
        $formData.append('image', $image);
        $formData.append('room_id', $params.room_id);
        $formData.append('user_id', libs.memoryGet('user_id'));
        $.ajax({
            type: 'POST',
            url: '/myDashboard/myInbox/chat/saveImage',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    inbox_delete_image_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/deleteImage',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Delete Users
    inbox_delete_user:function($params){
        var $modal = $("#nurseslounge-home-myinbox-group-manager");
        var $userList = $modal.find('.users-list');
        var $btnDelete = $userList.find('.btn-delete');
        $btnDelete.unbind().click(function(){
            var $that = $(this);
            var $item = $that.parents('.item:first');
            var $id = $item.data('id');
            $params = $.extend({}, $params, {id:$id});
            nurseslounge_myDashboard_myInbox.inbox_delete_user_request($params, function(){
                $item.remove();
                nurseslounge_myDashboard_myInbox.inbox_open_chat({
                    user_id:libs.memoryGet('user_id'),
                    room_id:$params.room_id,
                    my_room_id:$params.my_room_id,
                    limit:30
                });
            });
        });
    },
    inbox_delete_user_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/deleteUser',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Information
    inbox_edit_information_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/edit',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    inbox_information_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/list',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    inbox_delete_messages_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/delete',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    inbox_delete_group_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/chat/deleteGroup',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    inbox_write_message_request:function($params, cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/myInbox/message/set',
            data: $params,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    cback($data);
                }
            }
        });
    },
    //Socket Answer
    inbox_refresh_room_answer:function(){
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxRight = $inbox.find('.nurseslounge-home-my-inbox-right');
        var $roomId = $inboxRight.find('.heading-name-meta:first').data('room_id');
        if($roomId){
            socketFunctions.inbox_update_room(
                {
                    user_id:libs.memoryGet('user_id'),
                    room_id:$roomId,
                    limit:30
                }
            );
        }
    },
    inbox_update_room_answer:function($data){
        var $room = $data.room;
        var $chat = $room.chat;
        var $messages = $room.messages;
        var $inbox = $("#nurseslounge-home-my-inbox");
        var $inboxRight = $inbox.find('.nurseslounge-home-my-inbox-right');
        var $roomId = $inboxRight.find('.heading-name-meta:first').data('room_id');
        var $chatWrapper = $inboxRight.find('.colleagues-chat-wrapper');
        var $userId = libs.memoryGet('user_id');
        var $messageDivs = $chatWrapper.find('.message');
        var $ids = [];
        $messageDivs.each(function(){
            var $that = $(this);
            var $id = $that.data('id');
            $ids.push($id);
        });
        var $newMessages = [];
        $.each($messages, function($i, $v) {
            if($.inArray($v.id, $ids) == -1){
                $newMessages.push($v);
            }
        });
        var $firstMessageDivId = $messageDivs.first().data('id');
        var $lastMessageDivId = $messageDivs.last().data('id');
        var $chtml;
        if($roomId == $chat.id || $roomId == $room.my_room_id){
            $.each($newMessages, function($i, $v){
                if($userId == $v.user_id){
                    $chtml = '' +
                        '<div class="row message-body message" data-id="'+$v.id+'">' +
                        '    <div class="col-sm-12 message-main-sender">' +
                        '        <div class="sender">' +
                        '            <span class="message-time pull-right">' +
                        $v.created +
                        '            </span>' +
                        '            <div class="message-text">' +
                        $v.message +
                        '            </div>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>';
                }else{
                    $chtml = '' +
                        '<div class="row message-body message" data-id="'+$v.id+'">' +
                        '    <div class="col-sm-12 message-main-receiver">' +
                        '        <div class="receiver">' +
                        '            <span class="message-time pull-right">' +
                        $v.created +
                        '            </span>' +
                        '            <div class="message-text-title">' +
                        $v.long_name +
                        '            </div>' +
                        '            <div class="message-text">' +
                        $v.message +
                        '            </div>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>';
                }
                var $currentId = $($chtml).data('id');
                if($messageDivs.length == 0){
                    $chatWrapper.html($chtml);
                }
                if($lastMessageDivId < $currentId){
                    $messageDivs.last().after($chtml).ready(function(){
                        var $inbox = $("#nurseslounge-home-my-inbox");
                        var $inboxRight = $inbox.find('.nurseslounge-home-my-inbox-right');
                        var $chatWrapper = $inboxRight.find('.colleagues-chat-wrapper');
                        var $scrollHeight = $chatWrapper[0].scrollHeight;
                        var $offsetHeight = $chatWrapper[0].offsetHeight;
                        var $scrollTop = $scrollHeight - $offsetHeight;
                        $chatWrapper.scrollTop($scrollTop);
                    });
                }
                if($firstMessageDivId > $currentId){
                    $messageDivs.first().before($chtml);
                }
            });
        }
    }
};
